import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usd } from "@/lib/format";

const Cell = ({ label, value, sub, testid, accent }) => (
  <div className="py-4 pr-4">
    <p className={`text-2xl font-black tracking-tighter ${accent ? "rf-red" : ""}`} data-testid={testid}>{value}</p>
    <p className="rf-mono text-[10px] tracking-[0.2em] uppercase text-[var(--rf-grey)] mt-1">{label}</p>
    {sub && <p className="text-xs text-[var(--rf-grey)] mt-1">{sub}</p>}
  </div>
);

export const CreditsBar = () => {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/admin/credits").then((r) => setC(r.data)).catch(() => setC({})); }, []);
  if (!c) return null;
  const balance = c.account_credits != null ? c.account_credits - c.account_usage : null;
  const reset = { monthly: "si azzera ogni mese", weekly: "si azzera ogni settimana", daily: "si azzera ogni giorno" }[c.key_reset];
  return (
    <div className="border border-[var(--rf-ink)] px-5" data-testid="admin-credits-bar">
      <p className="rf-mono text-[10px] tracking-[0.3em] uppercase pt-4">Credito OpenRouter</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 divide-x-0">
        <Cell label="Saldo account" value={usd(balance, 2)} testid="admin-credits-balance" accent
          sub={c.account_credits != null ? `${usd(c.account_usage, 2)} usati su ${usd(c.account_credits, 2)}` : "non disponibile"} />
        <Cell label="Limite chiave residuo" value={usd(c.key_remaining, 2)} testid="admin-credits-key"
          sub={c.key_limit != null ? `su ${usd(c.key_limit, 0)}${reset ? `, ${reset}` : ""}` : "nessun limite"} />
        <Cell label="Speso da Reverse Frame" value={usd(c.app_spend, 3)} testid="admin-credits-app-spend" />
        <Cell label="Richieste IA" value={c.app_calls} testid="admin-credits-calls" sub="analisi + prompt per strumento" />
      </div>
    </div>
  );
};
